import { ContentItem } from "./types"

export const parseConsentVersion = (markdown: string): string => {
  const match = markdown.match(/<!--\s*version:\s*(.+?)\s*-->/)
  return match?.[1]?.trim() || "1.0"
}

export const parseMarkdown = (markdown: string): ContentItem[] => {
  const lines = markdown.split("\n")
  const contentItems: ContentItem[] = []
  let currentListItems: string[] = []

  const flushList = () => {
    if (currentListItems.length > 0) {
      contentItems.push({
        type: "list",
        items: [...currentListItems],
      })
      currentListItems = []
    }
  }

  lines.forEach((line) => {
    const trimmedLine = line.trim()
    if (!trimmedLine) return

  
    const cleanedLine = trimmedLine.replace(/\\\\/g, "").replace(/\\/g, "")

    const regexString = "^-center-\\*\\*(.+?)\\*\\*-/center-$"
    const regex = new RegExp(regexString)
    const centerMatch = cleanedLine.match(regex)
    if (centerMatch) {
      flushList()
      contentItems.push({
        type: "header-center",
        content: centerMatch[1].trim(),
        align: "center",
      })
      return
    }

    if (cleanedLine.startsWith("- ")) {
      const listContent = cleanedLine.replace(/^-\s+/, "").trim()
      currentListItems.push(listContent)
      return
    }

    flushList()
    const headerRegex = /^\*\*(.+)\*\*$/
    const match = cleanedLine.match(headerRegex)

    if (match) {
      const content = match[1]
      if (/^\d+\./.test(content)) {
        contentItems.push({
          type: "header",
          content: content,
          bold: true,
        })
        return
      }

      contentItems.push({
        type: "paragraph",
        content: cleanedLine,
      })
      return
    }

    contentItems.push({
      type: "paragraph",
      content: cleanedLine,
    })
  })

  flushList()
  return contentItems
}
